import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  inputWrapper: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 20
  },
  flexField: {
    display: "flex",
    width: "100%",
    marginBottom: 15,
    justifyContent: "left",
    alignItems: "center"
  },
  input: {
    appearance: "none",
    display: "block",
    width: 50,
    height: 50,
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: "50%",
    ":checked": {
      display: "block",
      width: 50,
      height: 50,
      background: colour.grey[300]
    }
  },
  label: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[400],
    paddingLeft: 15
  }
});
